import React, { useState } from 'react'

// Small circular avatar used across the Facebook Builder panel wherever an asset or Business Manager
// picture is shown (read-only rows, BM info headers, the change-confirmation dialog). Falls back to
// initials if there's no picture, or if the picture URL fails to load (public Graph picture URLs can
// 404 for assets with no profile photo).
const BmAvatar = ({
  name,
  pictureUri,
  size = 24,
}: {
  name?: string
  pictureUri?: string
  size?: number
}) => {
  const [failed, setFailed] = useState(false)

  return pictureUri && !failed ? (
    <img
      src={pictureUri}
      alt={name ?? 'Business'}
      onError={() => setFailed(true)}
      style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
    />
  ) : (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: '#F3E8FF',
        color: '#7C3AED',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size * 0.46,
        flexShrink: 0,
      }}
    >
      {name?.[0]?.toUpperCase() ?? '?'}
    </div>
  )
}

export default BmAvatar
